import { ApiProperty } from "@nestjs/swagger";

export class IndentItemRequest {
    @ApiProperty()
    indentItemId: number;
}